import React, { useState, useRef, useEffect } from "react"
import { Stage, Layer, Rect, Group } from 'react-konva';
import { Spring, animated } from 'react-spring/renderprops-konva';


const AnimatedRect = ({
    color,
    height,
    width,
    flag,
    delay = 0
}) => {
    return (
        <Spring
            native
            delay={delay * 250}
            from={{ x: 0, fill: color, width }}
            to={{
                x: 0,
                height: flag ? height : 0,
                width
            }}
        >
            {props => (
                <animated.Rect {...props} globalCompositeOperation={"darken"} />
            )}
        </Spring>
    )
}

export default ({ height = 400, width = 400 }) => {
    const [flag, setFlag] = useState(false);

    const onClick = () => {
        setFlag(!flag);
    }

    const rectProps = {
        flag,
        height,
        width
    }

    return (
        <div onClick={onClick} onTouchEnd={onClick}>
            <Stage width={width} height={height}>
                <Layer>
                    <Group>
                        <AnimatedRect color="magenta" {...rectProps} />
                        <AnimatedRect color="cyan" delay={1} {...rectProps} />
                        <AnimatedRect color="yellow" delay={2} {...rectProps} />
                    </Group>
                </Layer>
            </Stage>
        </div>
    );
}